{
  "de": {
    "nav": {
      "locations": "Orte",
      "home": "Startseite",
      "back": "Zurück",
      "navigation": "Navigation",
      "ships": {
        "index": "Schiffe"
      },
      "compare": {
        "index": "Vergleichen",
        "ships": "Schiffe Vergleichen"
      },
      "manufacturers": "Hersteller",
      "images": "Bilder",
      "videos": "Videos",
      "shipHistory": "Historie",
      "componentHistory": "Historie",
      "hangar": {
        "index": "Mein Hangar",
        "vehicleLoadouts": "Loadouts",
        "inventories": "Inventare",
        "vehicleCargo": "Fracht",
        "buybacks": "Rückkäufe",
        "paints": "Lackierungen",
        "flair": "Hangar-Flair",
        "imports": "Importe",
        "transfers": "Transfers"
      },
      "login": "Anmelden",
      "installApp": "App installieren",
      "logout": "Abmelden",
      "apiV1": "API v1",
      "apiV1Schema": "Schema",
      "apiV1Pagination": "Paginierung",
      "authApiV1": "Auth API v1",
      "authApiV1OpenId": "OpenID Connect",
      "authApiV1Schema": "Schema",
      "embed": "Einbettungswidget",
      "signUp": "Registrieren",
      "privacyPolicy": "Datenschutzerklärung",
      "impressum": "Impressum",
      "fleets": {
        "index": "Flotten",
        "add": "Neue Flotte erstellen",
        "invites": "Einladungen",
        "ships": "Schiffe",
        "blueprints": "Baupläne",
        "assets": "Bestand",
        "members": {
          "index": "Mitglieder",
          "invites": "Einladungen",
          "worldmap": "Weltkarte",
          "starmap": "Sternenkarte"
        },
        "squadrons": {
          "index": "Staffeln",
          "overview": "Übersicht",
          "members": "Mitglieder",
          "create": {
            "details": "Details",
            "appearance": "Erscheinungsbild",
            "discord": "Discord"
          },
          "edit": {
            "details": "Details",
            "appearance": "Erscheinungsbild",
            "discord": "Discord"
          }
        },
        "stats": "Statistiken",
        "logistics": {
          "index": "Logistics"
        },
        "missions": {
          "index": "Missionen",
          "edit": {
            "details": "Details",
            "teams": "Teams & Slots"
          }
        },
        "events": {
          "index": "Events",
          "calendar": "Kalender",
          "edit": {
            "details": "Details",
            "schedule": "Termin",
            "signup": "Anmeldung",
            "teams": "Teams & Slots"
          },
          "payouts": "Auszahlungen"
        },
        "tours": "Touren",
        "settings": {
          "index": "Einstellungen",
          "fleet": "Flotteneinstellungen",
          "rsi": "Flotten-ID & RSI",
          "membership": "Mitgliedschaftseinstellungen",
          "roles": "Rollen",
          "squadrons": "Staffeln",
          "allies": "Verbündete",
          "notifications": "Benachrichtigungen",
          "discord": "Discord",
          "calendar": "Kalender",
          "features": "Funktionen",
          "contracts": "Aufträge"
        },
        "contracts": {
          "index": "Aufträge",
          "payouts": "Auszahlung"
        },
        "directory": "Verzeichnis"
      },
      "rsiProfile": "RSI-Profil",
      "rsiHangar": "RSI-Hangar",
      "tools": {
        "index": "Werkzeuge",
        "travelTimes": "Reisezeiten",
        "cargoGrids": "Frachtgitter",
        "tradeRoutes": "Handelsrouten",
        "tours": "Touren"
      },
      "api": "API-Dokumentation",
      "stats": "Statistiken",
      "toggleSlimCollapse": "Zusammenklappen",
      "toggleSlimExpand": "Erweitern",
      "roadmap": {
        "index": "Roadmap",
        "overview": "Übersicht",
        "changes": "Änderungen",
        "ships": "Schiffe-Roadmap"
      },
      "rsiVerification": "RSI-Verifizierung",
      "settings": {
        "index": "Einstellungen",
        "profile": "Profil",
        "account": "Konto",
        "security": "Sicherheit",
        "notifications": "Benachrichtigungen",
        "calendar": "Kalender",
        "donations": "Spenden",
        "hangar": "Hangar",
        "privacy": "Datenschutz",
        "features": "Funktionen",
        "connections": "Verbindungen",
        "oauthApplications": "OAuth-Apps",
        "verify": "RSI-Kontoverifizierung",
        "friends": "Freunde"
      },
      "reload": "Update verfügbar!",
      "visualTests": {
        "blueprints": "Baupläne",
        "index": "Visuelle Tests",
        "panels": "Bereiche",
        "buttons": "Schaltflächen",
        "events": "Events",
        "typography": "Typografie",
        "forms": "Formulare",
        "tables": "Tabellen",
        "lists": "Listen",
        "metrics": "Metriken",
        "states": "Zustände",
        "notifications": "Benachrichtigungen",
        "syncModal": "Sync-Modal",
        "buybackSyncModal": "Rückkauf-Sync-Modal",
        "rsiVerificationModal": "RSI-Verifizierungs-Modal",
        "fleetRsiVerificationModal": "Flotten-RSI-Verifizierungs-Modal",
        "overlays": "Overlays",
        "installPrompt": "Installationshinweis",
        "supportHint": "Support-Hinweis",
        "media": "Medien",
        "charts": "Diagramme",
        "alerts": "Hinweise",
        "verifiedBadges": "Verifizierungsabzeichen",
        "chips": "Chips",
        "squadrons": "Staffeln",
        "groups": {
          "foundations": "Grundlagen",
          "data": "Daten",
          "feedback": "Feedback",
          "features": "Features"
        },
        "notificationCenter": "Benachrichtigungszentrale",
        "themes": "Themes"
      },
      "admin": {
        "features": {
          "overview": "Übersicht",
          "users": "Benutzer",
          "fleets": "Flotten",
          "history": "Verlauf"
        },
        "locations": {
          "index": "Orte"
        },
        "blueprints": {
          "index": "Baupläne"
        },
        "missions": {
          "index": "Missionen"
        },
        "index": "Admin",
        "models": {
          "index": "Modelle",
          "create": "Modell erstellen",
          "edit": {
            "index": "Basisdaten",
            "metrics": "Metriken",
            "prices": "Preise",
            "docks": "Andockplätze",
            "modules": "Module",
            "paints": "Lackierungen",
            "images": "Bilder",
            "videos": "Videos",
            "cargoAndFuel": "Fracht und Treibstoff",
            "cargoHolds": "Frachträume",
            "fleetchart": "Flottenkarten-Bilder",
            "positions": "Positionen",
            "hardpoints": "Aufhängungspunkte",
            "loaners": "Leihschiffe",
            "snubCrafts": "Snub Crafts",
            "upgrades": "Upgrades",
            "packages": "Pakete",
            "history": "Verlauf"
          }
        },
        "modelPaints": {
          "index": "Lackierungen",
          "create": "Lackierung erstellen"
        },
        "modelModules": {
          "index": "Module",
          "create": "Modul erstellen",
          "edit": {
            "index": "Basisdaten",
            "models": "Modelle",
            "prices": "Preise",
            "hardpoints": "Aufhängungspunkte",
            "docks": "Andockplätze",
            "cargoHolds": "Frachträume",
            "history": "Verlauf"
          }
        },
        "unlistedModels": {
          "index": "Nicht gelistete Schiffe"
        },
        "modelModulePackages": {
          "index": "Modulpakete",
          "create": "Modulpaket erstellen"
        },
        "components": {
          "index": "Komponenten",
          "edit": {
            "index": "Basisdaten",
            "prices": "Preise",
            "history": "Verlauf"
          }
        },
        "manufacturers": {
          "index": "Hersteller",
          "edit": {
            "index": "Basisdaten",
            "models": "Schiffe",
            "components": "Komponenten",
            "equipment": "Ausrüstung",
            "modules": "Module"
          }
        },
        "images": {
          "index": "Bilder"
        },
        "users": {
          "index": "Benutzer",
          "edit": "Bearbeiten",
          "fleets": "Flotten",
          "inventories": "Inventare",
          "supporterContributions": "Beiträge"
        },
        "fleets": {
          "index": "Flotten",
          "edit": "Bearbeiten",
          "members": "Mitglieder",
          "history": "Verlauf",
          "roles": "Rollen",
          "inventories": "Inventare"
        },
        "fleetFidClaims": {
          "index": "FID-Ansprüche"
        },
        "destroyedFleets": {
          "index": "Gelöschte Flotten"
        },
        "vehicles": {
          "index": "Fahrzeuge"
        },
        "admins": {
          "index": "Administratoren"
        },
        "oauthApplications": {
          "index": "OAuth-Apps"
        },
        "maintenance": {
          "index": "Wartung",
          "pghero": "PG-Hero",
          "features": "Funktionen",
          "workers": "Worker",
          "tasks": "Aufgaben",
          "imports": "Importe",
          "rsiApiStatus": "RSI-API-Status",
          "buildCompare": "Build-Vergleich"
        },
        "announcements": {
          "index": "Ankündigungen",
          "new": "Neue Ankündigung",
          "edit": "Ankündigung bearbeiten"
        },
        "supporterContributions": {
          "index": "Unterstützer-Beiträge",
          "new": "Neuer Beitrag",
          "edit": "Beitrag bearbeiten"
        },
        "fundingGoals": {
          "index": "Finanzierungsziele",
          "new": "Neues Finanzierungsziel",
          "edit": "Finanzierungsziel bearbeiten"
        },
        "notifications": {
          "index": "Benachrichtigungen"
        },
        "commodities": {
          "index": "Commodities",
          "edit": {
            "index": "Base Data"
          }
        },
        "equipment": {
          "index": "Equipment",
          "edit": {
            "index": "Base Data",
            "prices": "Prices"
          }
        },
        "visualTests": {
          "index": "Visuelle Tests",
          "notifications": "Benachrichtigungen"
        },
        "groups": {
          "catalogue": "Katalog",
          "community": "Community",
          "people": "Personen",
          "system": "System"
        }
      },
      "notifications": "Benachrichtigungen",
      "scDataSource": "Datenquelle",
      "commodities": {
        "index": "Handelswaren"
      },
      "components": {
        "index": "Komponenten"
      },
      "catalogue": {
        "commodities": "Handelswaren",
        "index": "Katalog",
        "components": "Komponenten",
        "blueprints": "Baupläne",
        "missions": "Missionen",
        "equipment": "Ausrüstung"
      },
      "equipment": {
        "index": "Ausrüstung"
      }
    }
  }
}
